import { render, staticRenderFns } from "./IlpaSlideshow.vue?vue&type=template&id=06270706&scoped=true"
import script from "./IlpaSlideshow.vue?vue&type=script&lang=js"
export * from "./IlpaSlideshow.vue?vue&type=script&lang=js"
import style0 from "./IlpaSlideshow.vue?vue&type=style&index=0&id=06270706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06270706",
  null
  
)

export default component.exports